/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, IconButton, TableCell, TableRow } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import * as Sentry from "@sentry/react";
import Modal from "../../../../components/common/Modal/Modal";
import Typography from "../../../../components/common/new/Typography/Typography";
import CustomTable from "../../../../components/common/new/Table/Table";
import Member from "../../../../services/api/member";
import Styles, { tabelCellWidth } from "./OrganizationStructure.styles";
import Loader from "../../../../components/common/Loader/Loader";

const REPLACE_COL = [
  {
    displayName: "POSITION",
    key: "memberId",
  },
  {
    displayName: "APPOINTMENT DATE",
    key: "memberName",
  },
  {
    displayName: "REMARK",
    key: "remark",
  },
];

export default function ReplacingModal({ open, onClose, selectedMember }) {
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAppointments = async () => {
      setIsLoading(true);
      try {
        const result = await Member.getAppointmentsByMemberId(selectedMember);
        const { content } = result.data;
        setSearchResult(content);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        Sentry.captureException(err);
      }
    };

    if (open) {
      fetchAppointments();
    }
  }, [open, selectedMember]);

  const getRows = () => {
    if (!Array.isArray(searchResult)) {
      return null;
    }

    if (searchResult.length === 0) {
      return (
        <TableRow>
          <TableCell colSpan={3} style={{ textAlign: "center" }}>
            No data available
          </TableCell>
        </TableRow>
      );
    }

    return searchResult.map((item) => (
      <TableRow key={item.id}>
        <TableCell>{item.appliedForName || "NA"}</TableCell>
        <TableCell>
          {item.createdAt ? moment(item.createdAt).format("DD/MM/YYYY") : "NA"}
          {/* {item.appointedAt
            ? moment(item.appointedAt).format("DD/MM/YYYY")
            : "NA"} */}
        </TableCell>
        <TableCell
          style={{
            ...Styles.greyTableCell,
            ...tabelCellWidth.medium,
          }}
        >
          <Typography
            variant="small"
            style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.87)" }}
          >
            {item.remark || "NA"}
          </Typography>
        </TableCell>
      </TableRow>
    ));
  };
  const rows = getRows();

  return (
    <Box>
      <Modal
        open={open}
        customStyle={{
          height: "95%",
          overflowY: "auto",
          width: "95vw",
          maxWidth: "1200px",
        }}
      >
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography
            style={{
              fontSize: "20px",
              fontWeight: "600",
              paddingBottom: "20px",
            }}
          >
            Member Appointment History
          </Typography>
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </Box>
        <CustomTable
          columnCellStyle={{ textAlign: "left" }}
          scrollable
          columns={REPLACE_COL}
          rows={rows}
          tableBodyTheme="#F6F6F6"
          tableHeadCellStyle={{
            ...Styles.tableHeadCells,
          }}
          isLoading={isLoading}
        />
        {isLoading && <Loader />}
      </Modal>
    </Box>
  );
}
